import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import CorePrograms from "../components/CorePrograms";
import About from "../components/About";
import Marquee from "../components/Marquee";
import Services from "../components/Services";
import Directors from "../components/Directors";
import Gallery from "../components/Gallery";
import Testimonials from "../components/Testimonials";
import Instagram from "../components/Instagram";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";
import useScrollReveal from "../hooks/useScrollReveal";

export default function Home() {
  useScrollReveal();
  return (
    <div className="relative">
      <Navbar />
      <main>
        <Hero />
        <CorePrograms />
        <About />
        <Marquee />
        <Services />
        <Directors />
        <Gallery />
        <Testimonials />
        <Instagram />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
